/** Shared helpers for master / sub-organization hierarchy in org pickers. */

export interface OrgHierarchyNode {
    _id: string;
    name?: string;
    isMasterOrganization?: boolean;
    parentOrganizationId?: string | { _id?: string };
}

export function getParentOrganizationId(
    org: OrgHierarchyNode | null | undefined
): string | null {
    if (!org?.parentOrganizationId) return null;
    const parent = org.parentOrganizationId;
    if (typeof parent === 'string') return parent;
    return parent._id ?? null;
}

/** Master org id for lazy-loading children (selected master or sub-org's parent). */
export function getMasterOrgIdForChildren(
    org: OrgHierarchyNode | null | undefined
): string | null {
    if (!org?._id) return null;
    if (org.isMasterOrganization) return org._id;
    return getParentOrganizationId(org);
}

export function mergeOrganizationsWithSubOrgs<T extends { _id: string }>(
    baseOrgs: T[],
    subOrgs: T[]
): T[] {
    if (!subOrgs.length) return baseOrgs;
    const seen = new Set(baseOrgs.map((org) => org._id));
    const merged = [...baseOrgs];
    for (const sub of subOrgs) {
        if (!seen.has(sub._id)) {
            seen.add(sub._id);
            merged.push(sub);
        }
    }
    return merged;
}
